module.exports = __webpack_public_path__ + "img/img2.68151476.png";